import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { useRemoveCalendarHolidays } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function CalendarHolidaysRemoval({ cancel, calendarHolidays }: Props) {
  const { t } = useTranslation();
  const { removeCalendarHolidays, isRequestPending } =
    useRemoveCalendarHolidays(calendarHolidays);

  return (
    <Modal
      header={t("calendarHolidays.removal.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("calendarHolidays.removal.confirmation")}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("calendarHolidays.removal.cancel")}
          </Button>
          <Button
            type={"delete"}
            status={isRequestPending ? "pending" : "none"}
            press={() => removeCalendarHolidays(calendarHolidays)}
          >
            {t("calendarHolidays.removal.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { CalendarHolidaysRemoval };
